import React from "react";
import { Form, Input, Button, Row, Col, Card } from "antd";
import { MailOutlined, PhoneOutlined, EnvironmentOutlined } from "@ant-design/icons";

const Contact = () => {
    const onFinish = (values) => {
        console.log("Form values:", values);
        // Ici, vous pouvez envoyer les données via une API si nécessaire
    };

    return (
        <div style={{ padding: "20px" }}>
            <h1 style={{ textAlign: "center", marginBottom: "30px", color: "#004b8d" }}>Nous Contacter</h1>
            <Row gutter={[16, 16]}>
                {/* Section Informations */}
                <Col xs={24} sm={24} md={12}>
                    <Card
                        title="Informations de Contact"
                        bordered={false}
                        style={{ borderRadius: "10px", boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)" }}
                    >
                        <p>
                            <MailOutlined style={{ color: "#004b8d", marginRight: "10px" }} />
                            <strong>Email :</strong> contact@nomidya.com
                        </p>
                        <p>
                            <PhoneOutlined style={{ color: "#004b8d", marginRight: "10px" }} />
                            <strong>Téléphone :</strong> +212 6 12 34 56 78
                        </p>
                        <p>
                            <EnvironmentOutlined style={{ color: "#004b8d", marginRight: "10px" }} />
                            <strong>Adresse :</strong> 123 Rue des Startups, Casablanca, Maroc
                        </p>
                    </Card>
                </Col>

                {/* Section Formulaire */}
                <Col xs={24} sm={24} md={12}>
                    <Card
                        title="Envoyez-nous un Message"
                        bordered={false}
                        style={{ borderRadius: "10px", boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)" }}
                    >
                        <Form
                            name="contactForm"
                            layout="vertical"
                            onFinish={onFinish}
                            initialValues={{ remember: true }}
                        >
                            <Form.Item
                                label="Nom Complet"
                                name="name"
                                rules={[{ required: true, message: "Veuillez entrer votre nom complet !" }]}
                            >
                                <Input placeholder="Entrez votre nom complet" />
                            </Form.Item>

                            <Form.Item
                                label="Email"
                                name="email"
                                rules={[
                                    { required: true, message: "Veuillez entrer votre email !" },
                                    { type: "email", message: "Veuillez entrer un email valide !" },
                                ]}
                            >
                                <Input placeholder="Entrez votre email" />
                            </Form.Item>

                            <Form.Item
                                label="Message"
                                name="message"
                                rules={[{ required: true, message: "Veuillez entrer votre message !" }]}
                            >
                                <Input.TextArea placeholder="Entrez votre message" rows={4} />
                            </Form.Item>

                            <Form.Item>
                                <Button type="primary" htmlType="submit" block style={{ backgroundColor: "#004b8d" }}>
                                    Envoyer le Message
                                </Button>
                            </Form.Item>
                        </Form>
                    </Card>
                </Col>
            </Row>
        </div>
    );
};

export default Contact;
